import './Tracking.scss';

import React, { useContext, useMemo } from 'react';
import { MetroContext, type MetroContextType } from '@bblabs/module-library/classes';
import { Livefire } from '@bblabs/module-library/organisms';
import { livefireItemTypes } from '@bblabs/module-library/constants';
import { environment } from '../../environment';
import { useFilteredTracking } from '../hooks/useFilteredTracking';
import { MetricService } from '../services/MetricService';
import { useLivefireFilters } from '../hooks/useLivefireFilters';
import { livefireApi } from '../hooks/useLivefireApi';
import { ProxyLivefire } from '../lib/ProxyLivefire';
import { UserContext } from './App';

/**
 * Livefire tracking feed tab
 */
export const Tracking = () => {
  const user = useContext(UserContext);
  const inheritedMetroContext = useContext(MetroContext);
  const metroContext: MetroContextType = useMemo(
    () => ({
      ...inheritedMetroContext,
      appName: MetricService.getAppName(),
      clientId: user.user?.get('clientId') ?? '',
    }),
    [inheritedMetroContext, user.user],
  );

  const [filterItem, setFilteredItem] = useFilteredTracking();

  const { filterState, onFilterStateChange } = useLivefireFilters();

  if (!user || !user.token) {
    return null;
  }

  const token = user.token.getAccessToken();
  if (!token) {
    return null;
  }

  const cardTypes = [
    livefireItemTypes.click,
    livefireItemTypes.open,
    livefireItemTypes.play,
    livefireItemTypes.comment,
    livefireItemTypes.like,
    livefireItemTypes.sent,
    livefireItemTypes.videoWatched,
    livefireItemTypes.replyWithVideo,
  ];
  const proxyLivefire = new ProxyLivefire(livefireApi, { cardTypes, feeds: ['default'] });

  return (
    <MetroContext.Provider value={metroContext}>
      <Livefire
        api={proxyLivefire}
        className="tab--tracking"
        authToken={token}
        environment={environment}
        onSearchTermChange={setFilteredItem}
        searchTerm={filterItem}
        showFilterOptions
        filterState={filterState}
        onFilterStateChange={onFilterStateChange}
      />
    </MetroContext.Provider>
  );
};
